/* Copie klikcamera.com sur Dawn : aides communes aux sections kc-*.
   - KC.brand                         nom de marque (Réglages du thème > CLIC)
   - KC.money(cents)                  prix au format de la boutique
   - KC.cart.add(items)               ajoute [{id, quantity, properties}] et ouvre le tiroir panier de Dawn
                                      (même rendu que le bouton « Ajouter au panier » de Dawn)
   - KC.initAnimations(root)          apparition au défilement des éléments [data-kc-animate] */
(function () {
  const config = window.KC_CONFIG || {};

  function formatWithDelimiters(number, precision, thousands, decimal) {
    if (isNaN(number) || number == null) return '0';
    const parts = (number / 100).toFixed(precision).split('.');
    const whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }

  function money(cents, format) {
    cents = Number(cents);
    format = format || config.moneyFormat || '{{amount_with_comma_separator}} €';
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return formatWithDelimiters(cents, 2, ',', '.');
        case 'amount_no_decimals': return formatWithDelimiters(cents, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return formatWithDelimiters(cents, 0, '.', ',');
        case 'amount_with_space_separator': return formatWithDelimiters(cents, 2, ' ', ',');
        case 'amount_with_apostrophe_separator': return formatWithDelimiters(cents, 2, "'", '.');
        default: return formatWithDelimiters(cents, 2, '.', ',');
      }
    });
  }

  async function add(items) {
    const cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const body = { items: items };
    if (cartEl && cartEl.getSectionsToRender) {
      body.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    const res = await fetch((window.routes ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const json = await res.json();
    if (!res.ok || json.status) throw json;
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kc', productVariantId: items[0] && items[0].id, cartData: json });
    }
    if (cartEl && cartEl.renderContents) {
      json.id = items[0] && items[0].id;
      if (cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
      cartEl.renderContents(json);
    }
    return json;
  }

  function initAnimations(root) {
    const els = (root || document).querySelectorAll('[data-kc-animate]:not(.is-visible)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-visible'); }); return; }
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  window.KC = { brand: config.brand || 'CLIC', money: money, cart: { add: add }, initAnimations: initAnimations };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAnimations(); });
  else initAnimations();
  document.addEventListener('shopify:section:load', function (e) { initAnimations(e.target); });
})();
